import { createAction } from '@reduxjs/toolkit';

import { ExpandableContentTogglePayload } from '../types';

export const onViewResultsClick = createAction('filter/onViewResultsClick');

export const onExpandableContentToggle = createAction<ExpandableContentTogglePayload>(
  'filter/onExpandableContentToggle',
);
